import { IPqrSearch } from './../interfaces/pqr-search-interface';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pqr-search',
  templateUrl: './pqr-search.component.html',
  styleUrls: ['./pqr-search.component.scss'],
})
export class PqrSearchComponent {
  public codeControl = new FormControl('', Validators.required);
  public recaptcha = new FormControl('', Validators.required);
  public pqrResult: IPqrSearch | null = null;
  public isLoading = false;

  constructor(private http: HttpClient) {}

  public getResponseDate(): string | null {
    if (!this.pqrResult || !this.pqrResult.pqr_messages) {
      return null;
    }
    const responseMsg = this.pqrResult.pqr_messages.find(
      (m) => m.sender_type === 'User'
    );
    return responseMsg ? responseMsg.created_at : null;
  }

  public handleSearch(): void {
    if (this.codeControl.invalid || !this.recaptcha.valid) {
      return;
    }

    this.isLoading = true;
    this.pqrResult = null;

    this.http
      .get<IPqrSearch>(
        `${environment.apiUrl}/pqrs/${this.codeControl.value}`
      )
      .subscribe(
        (data) => {
          this.pqrResult = data;
          this.isLoading = false;
          this.recaptcha = new FormControl('', Validators.required);
        },
        () => {
          this.isLoading = false;
          this.recaptcha = new FormControl('', Validators.required);
          Swal.fire({
            icon: 'error',
            title: 'PQR no encontrada',
            text: 'No se encontro ninguna PQR con el codigo ingresado',
            confirmButtonText: 'Entendido',
          });
        }
      );
  }

  public printPage(): void {
    window.print();
  }
}
